import React, {Component} from 'react';
import {FadeIn} from 'animate-components';

const proProjects = [{
      title: 'Regulatory Authority of Electronic and Postal Communications - Management Software',
      description: 'If you want to provide electronic communications services in Kosovo, you can use this software and fill out online the request for authorization from the RAEPC (Regulatory Authority of Electronic and Postal Communications). When you are officially Authorized to offer Electronic Communications in Kosovo, you will be also able to have your own profile and then submit 3 monthly reports on your services.',
      technologies: 'Python(Flask), MongoDB, JavaScript, HTML5, Jinja, Bootstrap',
      role: 'Software Developer',
      link: 'http://aplikime.arkep-rks.org/EN',
      github: ''
   }, {
      title: 'Open Businesses',
      description: 'Open Businesses is a business registration search engine with data from over 170,000 businesses in Kosovo. The data was scraped from the Kosovo Business Registration Agency (ARBK). Opening business data allows economic analysis of sectors as well as various economic activities. It creates space for analyzing economic trends in different periods and regions. It creates space for market analysis by local and international investors. Opening these business data enables data linking with other sectors such as public procurement or property declaration, which would strengthen anti-corruption mechanisms.',
      technologies: 'Python(Flask), MongoDB, JavaScript, HTML5, Jinja, Bootstrap',
      role: 'Software Developer',
      link: 'http://biznesetehapura.com/en',
      github: 'https://github.com/opendatakosovo/open-arbk'
   }, {
      title: 'Amnesty International Human Rights Education Micro Learning Platform',
      description: 'Amnesty International Human Rights Education Micro Learning Platform is an online application where people all over the world can submit a questionnaire, and by completing this questionnaire, they will get some initial ideas on human rights and human rights defenders. This will support them to begin the learning package which follows. After they sign in, they can enter and follow the lessons in courses provided, they can submit quizzes in courses and exercises.',
      technologies: 'Python(Flask), MongoDB, JavaScript, HTML5, Jinja, Bootstrap',
      role: 'Software Developer',
      link: 'https://www.humanrightseducation.amnesty.org/en/',
      github: ''
   }, {
      title: 'Asset Declarations in CEE Countries',
      description: 'This is an assessment of efficiency and functioning of asset disclosure systems in 18 CEE countries. The data was collected through a survey conducted in the summer of 2017. You can: Check given country’s implementation, compare systems between countries, read the full-text report, applaud report’s contributors, contribute with your own data',
      technologies: 'Jekyll, JavaScript, JSON, Jinja, HTML5, CSS3',
      role: 'Software Developer',
      link: 'http://assetdeclarations.transparencee.org/',
      github: 'https://github.com/opendatakosovo/cee-asset-declarations'
   }, {
      title: 'UNKT Sustainable Development Goals Visualizations - Management Tool',
      description: 'A Wordpress management tool plugin for UNKT website. The plugin will have an admin dashboard to manage targets, indicators inside targets and to create different kind of charts to show visualizations for public.',
      technologies: 'PHP, JavaScript, Wordpress, JSON, MySQL, HTML5',
      role: 'Software Developer',
      link: 'http://unkt.org/sdg',
      github: 'https://github.com/opendatakosovo/unkt-sdg-plugin'
   }, {
     title: 'Open Data Kosovo - Website',
     description: 'The official Open Data Kosovo website helps you to find out what are the main principles and services of this organization. All projects are listed in the Projects page. See what others think about us in the Testimonials page. Read publications and articles in the Publications and Media pages. Wondering about the team and the office place, find out in the About page.',
     technologies: 'Jekyll, JavaScript, Jinja, HTML5, CSS3',
     role: 'Software Developer',
     link: 'http://opendatakosovo.org',
     github: ''
  }
];

const openSourceProjects = [{
      title: 'ReactBlog',
      description: 'Simple blog built with React, React Router and Redux Form.',
      technologies: 'ReactJS, JavaScript, Redux, Bootstrap',
      github: 'https://github.com/arianithetemi/ReactBlog'
   }, {
      title: 'WeatherAppReact',
      description: 'A weather app crafted with ReactJS and Redux',
      technologies: 'ReactJS, JavaScript, Redux, Bootstrap',
      github: 'https://github.com/arianithetemi/WeatherAppReact'
   }, {
      title: 'React Youtube Project',
      description: 'Web App which provides you search ability in all youtube videos with YT API!',
      technologies: 'ReactJS, JavaScript, Youtube API, Bootstrap',
      github: 'https://github.com/arianithetemi/ReactYoutubeProject'
   }, {
      title: 'Laravel Blog',
      description: 'Blog system built with laravel.',
      technologies: 'PHP, Laravel, HTML5, Bootstrap',
      github: 'https://github.com/arianithetemi/laravel-blog'
   }, {
      title: 'Flask App Framework',
      description: 'Flask App Framework is a flexible boilerplate for implementing you flask application.',
      technologies: 'Python, Flask',
      github: 'https://github.com/arianithetemi/flask-app-framework'
   }, {
      title: 'PHP Auth',
      description: 'Simple authentication and authorization handled by pure PHP',
      technologies: 'PHP, MySQL, HTML5',
      github: 'https://github.com/arianithetemi/php-auth'
   }
];

class Projects extends Component {
   render() {
      return (
         <div className="main">
            <FadeIn duration="1.2s" timingFunction="ease-out">
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="about-title">Professional Projects</h3>
                  </div>
                  <div className="col-md-9">
                     {proProjects.map((data, index) => {
                        const {title, description, technologies, role, link, github} = data;

                        var gitText = '';
                        if (github !== '') {
                           gitText = 'Source Code: ';
                        }

                        return (
                           <div key={index} className="project-card">
                              <p className="project-name">{title}</p>
                              <p><b>Description</b>: {description}</p>
                              <p><b>Technologies</b>: {technologies}</p>
                              <p><b>Role:</b> {role}</p>
                              <p><b>Link</b>: <a href={link} target="_blank">{link}</a></p>
                              <p><b>{gitText}</b> <a href={github} target="_blank">{github}</a></p>
                           </div>
                        )
                     })}
                  </div>
               </div>
               <hr />
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="personal-projects-title">Personal Open Source Projects</h3>
                  </div>
                  <div className="col-md-9 personal-projects-container">
                     {openSourceProjects.map((data, index) => {
                        const {title, description, technologies, github} = data;

                        return (
                           <div key={index} className="project-card">
                              <p className="project-name">{title}</p>
                              <p><b>Description</b>: {description}</p>
                              <p><b>Technologies</b>: {technologies}</p>
                              <p><b>Source Code: </b> <a href={github} target="_blank">{github}</a></p>
                           </div>
                        )
                     })}
                  </div>
               </div>
            </FadeIn>
         </div>
      );
   }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects.js